// All copy + image locations live here.
// You can add/remove blocks without touching JSX.

export const discountsIntro = {
  title: "Aktuális akciók Debrecenben",
  subtitle: "Törzsvásárlói és csoportos kedvezmények",
};

export const discounts = [
  {
    id: "group",
    heading: "Csoportos kedvezmény",
    bullets: [
      "Rendeljetek Debrecenben házhozszállításra 4 db pizzát, és egy 2,25 L-es Coca-Colát adunk ajándékba!",
      "Az akció a törzsvásárlói kedvezménnyel egyszerre nem használható fel, és maximum 16 db pizzáig érvényes.",
    ],
    cta: {
      label: "Hamarosan >>",
      href: "https://debrecenipizza.hu/",
    },
    hero: "/images/discounts/group-discount.webp",
    imageSide: "left",
  },

  {
    id: "loyalty",
    heading: "Törzsvásárlói kedvezmény",
    bullets: [
      "Gyűjts össze 10 db házikót a dobozokról egy AJÁNDÉK pizzáért! Az étlapról bármilyen pizza választható.",
      "Az akció más kedvezménnyel nem összevonható. A kedvezmény igénybevételét telefonos rendeléskor vagy a debrecenipizza.hu oldalon megjegyzésben előre jelezni kell!",
      "Az akció teljes kiőrlésű tésztára és extra feltétekre nem vonatkozik.",
    ],
    cta: {
      label: "Hamarosan >>",
      href: "https://debrecenipizza.hu/",
    },
    hero: "/images/discounts/regular-customer.webp",
    imageSide: "right",
  },
];
